import React, { useState } from 'react';
import { Card, Form, Button, ProgressBar } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';

const BulkUploadRegisteredSW = ({ onResult }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const validateFile = (file) => {
    const validTypes = [
      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      'application/vnd.ms-excel',
      'text/csv'
    ];
    if (!validTypes.includes(file.type)) {
      toast.error('Please upload only Excel/CSV files');
      return false;
    }
    return true;
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile && validateFile(selectedFile)) {
      setFile(selectedFile);
    } else {
      setFile(null);
    }
  };

  const handleUpload = async () => {
    if (!file) {
      toast.error('Please select a file for Registered at StartupWorld upload');
      return;
    }
    try {
      setUploading(true);
      setUploadProgress(0);
      const formData = new FormData();
      formData.append('file', file);
       const base = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');
      const response = await axios.post(`${base}/api/upload/registered-startupworld`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (progressEvent) => {
          const progress = (progressEvent.loaded / progressEvent.total) * 100;
          setUploadProgress(Math.round(progress));
        }
      });
      toast.success(response.data.message || 'Registered at StartupWorld upload successful');
      onResult(response.data, 'registeredSW');
    } catch (error) {
        console.error(error);
      toast.error(error.response?.data?.message || 'Failed to process Registered at StartupWorld file');
    } finally {
      setUploading(false);
      setFile(null);
    }
  };

  return (
    <Card className="mb-4">
      <Card.Header>
        <h5>Upload Registered at StartupWorld (Excel/CSV)</h5>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label>Select File for Registered at StartupWorld Applicants</Form.Label>
          <Form.Control
            type="file"
            accept=".xlsx,.xls,.csv"
            onChange={handleFileChange}
            disabled={uploading}
          />
        </Form.Group>
        <Button
          variant="info"
          onClick={handleUpload}
          disabled={!file || uploading}
        >
          {uploading ? 'Processing...' : 'Upload Registered at StartupWorld'}
        </Button>
        {uploading && <ProgressBar now={uploadProgress} label={`${uploadProgress}%`} className="mt-2" />}
      </Card.Body>
    </Card>
  );
};

export default BulkUploadRegisteredSW;